import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Panel, Button } from 'react-bootstrap';
import FormField from './FormField';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { generateToken } from '../Utils';
import * as actions from '../actions/actions';

class LaunchOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      token: '',
      randomPressed: false
    };
  }

  launchOptionChanged = function(name, value) {
    console.log('launchOptionChanged', name, value);

    this.props.launchOptionChanged2(name, value);

    if (name === 'ccy') {
      let token = generateToken(this.props, value);
      this.props.launchOptionChanged2('token', token);
      this.props.launchOptions.set('token');
    }

    //this.createRandomToken()
  };

  createRandomToken = function() {
    let token = generateToken(this.props);

    //this.setState({token : token});
    this.setState({ randomPressed: true }, () => {
      this.launchOptionChanged('token', token);
    });
  };

  componentWillReceiveProps(nextProps) {
    //  console.log('nextProps', nextProps);

    //  this.props.launchOptions.get('ccy')
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (
      nextProps.launchOptions.get('token') !== this.state.token &&
      this.state.randomPressed
    ) {
      this.setState({ token: nextProps.launchOptions.get('token') });
    }
  }

  render() {
    // console.log(this.props.config)
    return (
      <div>
        <Button
          bsStyle="primary"
          block
          onClick={() => this.setState({ open: !this.state.open })}
        >
          Launch Options
        </Button>
        <Panel collapsible expanded={this.state.open}>
          <div className="input-group">
            <FormField
              configID="token"
              label="Token"
              type="text"
              placeholder={this.props.launchOptions.get('token')}
              onChange={this.launchOptionChanged.bind(this)}
              value={this.state.token}
            />
            <span
              className="input-group-btn"
              style={{ verticalAlign: 'bottom' }}
            >
              <Button
                onClick={() => this.createRandomToken()}
                bsSize="small"
                bsStyle="link"
              >
                {' '}
                random{' '}
              </Button>
            </span>
          </div>
          <FormField
            configID="language"
            label="Language"
            type="select"
            options={this.props.config.get('languages')}
            onChange={this.launchOptionChanged.bind(this)}
          />
          <FormField
            configID="ccy"
            label="Currency"
            type="select"
            options={this.props.config.get('currencies')}
            onChange={this.launchOptionChanged.bind(this)}
          />
          <FormField
            configID="extraParams"
            label="URL params"
            type="text"
            value={this.props.launchOptions.get('extraParams')}
            onChange={this.launchOptionChanged.bind(this)}
          />
        </Panel>
      </div>
    );
  }
}

LaunchOptions.propTypes = {
  gameInfo: PropTypes.object.isRequired,
  config: ImmutablePropTypes.map,
  launchOptions: ImmutablePropTypes.map
};

const mapStateToProps = state => {
  return {
    state
  };
};

const mapDispatchToEvents = dispatch => {
  return {
    launchOptionChanged2: (name, value) => {
      dispatch(actions.setLaunchOptions({ name: name, value: value }));
    }
  };
};

const LaunchOptionsConnected = connect(
  mapStateToProps,
  mapDispatchToEvents
)(LaunchOptions);

export default LaunchOptionsConnected;



// WEBPACK FOOTER //
// ./src/components/LaunchOptions.js